import { Alert, VStack, Box } from '@chakra-ui/react';
import React from 'react';

import { DataPipeline } from '@finley-technologies/finley-types';

import { MeshMiniCard } from 'packages/dataPipeline/ui/list/MeshCard';
import { SelectedMeshRun } from '~/packages/dataPipeline/types/dataPipelineTypes';

export const PipelineSelectorPane = ({
  recentMeshRuns,
  onPipelineSelected,
  children,
}: {
  recentMeshRuns: DataPipeline.MeshRunRecordWithMeshDocument[];
  onPipelineSelected(selectedMeshRun: SelectedMeshRun): void;
  children: React.ReactNode;
}) => {
  return (
    <VStack spacing="16px" width="100%" alignItems="flex-start">
      {recentMeshRuns.length === 0 && (
        <Alert>
          There are no latest reports that align with the current data pipeline.
        </Alert>
      )}
      {recentMeshRuns.map((meshRow) => {
        return (
          <MeshMiniCard
            key={meshRow.meshRunId}
            meshRow={meshRow}
            onPipelineSelected={onPipelineSelected}
          />
        );
      })}
      <Box alignSelf="flex-end">{children}</Box>
    </VStack>
  );
};
